<template>
    <div class="tableTempleteBox" id="tableTempleteBox">
        <el-table id="elTable" :data="tableDataVal"  v-loading = "isLoading" element-loading-background = "rgba(0, 0, 0, 0.3)"
                  element-loading-text = "数据正在加载中" element-loading-spinner = "el-icon-loading"
                  ref="tableList" border stripe highlight-current-row size="mini" height="100%"
                  :row-class-name="tableRowClassName"
                  :cell-class-name="cellClass"
                  @row-click="toggleSelection" @selection-change="selectionChange" @header-dragend="headDrog"
                  @sort-change="sortThisColumn"
                  >
            <el-table-column class-name="tableIndex" v-if="isIndex" type="index" align="center" width="45"></el-table-column>
            <el-table-column class-name="tableIndex" v-if="isHideColumn" type="selection" align="center" :selectable="checkSelectable" width="45"></el-table-column>
            <el-table-column class-name="tableIndex" label="操作" align="center" :width="operationWidth ? operationWidth:85" v-if="operation">
                <template slot-scope="scope">
                    <span class="oper_fore" v-if="scope.row.isForeclosure" @click.stop="foreclosure(scope.row.id,scope.row)">去赎货</span>
                    <i class="operation_edit" v-if="scope.row.isEdit" @click.stop="edit(scope.row.id,scope.row)" title="修改"></i>
                    <i class="operation_delete" v-if="scope.row.isDelete" @click.stop="deleteF(scope.row.id,scope.row)" title="删除"></i>
                    <i class="operation_see" v-if="scope.row.isSee" @click.stop="see(scope.row.id)" title="查看"></i>
                    <i class="operation_reback" v-if="scope.row.isRevoke" @click.stop="recall(scope.row.id,scope.row)" title="撤销"></i>
                    <i class="operation_rebackC" v-if="scope.row.isCancel" @click.stop="isCancel(scope.row.id)" title="撤回"></i>
                    <i class="operation_saleDetail" v-if="scope.row.isDetail" @click.stop="seeSaleBill(scope.row.id,scope.row)" title="销售单"></i>
                    <i class="operation_transfer" v-if="scope.row.is_transfer" @click.stop="transfer(scope.row.id,scope.row)" title="调货"></i>
                    <!-- <div class="icon_wrap" style="width:70px;">
                    </div> -->
                </template>
            </el-table-column>
            <template v-for="(item,index) in tableColVal">
                <el-table-column :render-header="renderHeader" :column-key="index.toString()"
                    :prop="item.colKey" v-if="item.isShow!==false" :key="index" :label="item.colName"
                    :sortable="item.isSort ? 'custom' : false"
                    :width="item.isSetWidth!==false ? (item.colWidth?item.colWidth:100)+ 'px' : ''"
                    :align="item.align?item.align:'left'"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                        <div class="tdClick" v-if="item.isCanClick" :style="(item.isHideCanClickColor?item.isColor?'color:'+scope.row.baseColor+';':'':'color:#ff0000;')+(scope.row[item.colKey]=='-'?'':'text-decoration: underline;cursor:pointer;')" @click.stop="rowClick(scope.row.id,item.colKey,scope.row)">
                            <div class="tdClickImage" v-if="!item.isHideShowClickImg&&scope.row[item.colKey]"></div>
                            {{ scope.row[item.colKey] }}
                        </div>
                        <div class="tdClick" v-else-if="item.isCanClickNoColor" :style="'text-decoration: underline;cursor:pointer;'" @click.stop="rowClick(scope.row.id,item.colKey,scope.row)">
                            <div class="tdClickImage" v-if="!item.isHideShowClickImg&&scope.row[item.colKey]"></div>
                            {{ scope.row[item.colKey] }}
                        </div>
                        <div class="tdClick" v-else-if="item.isCanRongClick" :style="'text-decoration: underline;cursor:pointer;color:#ff0000;'" @click.stop="rowClick(scope.row.id,item.colKey,scope.row)">
                            <div class="tdRongClickImage" v-if="!item.isHideShowClickImg&&scope.row[item.colKey]"></div>
                            {{ scope.row[item.colKey] }}
                        </div>
                        <div class="tdClick" v-else-if="item.isRong" :style="'text-decoration: underline;cursor:pointer;color:#ff0000;'" @click.stop="rowClick(scope.row.id,item.colKey,scope.row)">
                            <div class="tdRongClickImage" v-if="!item.isHideShowClickImg&&scope.row.isDialogViewrong"></div>
                            <div class="tdClickImage"  v-else></div>
                            {{ scope.row[item.colKey] }}
                        </div>
                        <!-- 后面带图片锁 -->
                        <div class="tdClick" v-else-if="item.isCanClickLocks">
                            <div class="tdlocksImage" v-if="scope.row.isDialogViewlocks"></div>
                            <!-- <span class="dialoglocks tdIcon" style="cursor:pointer;" v-if="scope.row.isDialogViewlocks"></span> -->
                            {{ scope.row[item.colKey] }}
                        </div>
                        <div class="tdClick" v-else-if="item.isPoint" :style="'text-decoration: underline;text-decoration-color:#ff0000;'" @click.stop="rowClick(scope.row.id,item.colKey,scope.row)">
                            <!-- {{ scope.row[item.colKey] }} -->
                            <span  :style="item.isColor?'color:'+scope.row.baseColor:''">
                            <span v-if="scope.row[item.colKey] == '未签' " style="color:red">
                                {{ scope.row[item.colKey] }}
                            </span>
                            <span v-else>
                                {{ scope.row[item.colKey] }}
                            </span>
                        </span>
                        </div>
                        <!--字段为数字>0时可点击-->
                        <div class="tdClick cursorPointer" v-else-if="item.isGt0Click" :style="scope.row[item.colKey]>0?'color:#3072DD;text-decoration: underline;':''"
                             @click.stop="scope.row[item.colKey]>0?rowClick(scope.row, item.colKey):''">
                            {{ scope.row[item.colKey] }}
                        </div>
                        <div class="tdClick cursorPointer" v-else-if="item.isToDetail"
                             :style="item.cusStyle?item.cusStyle:'color:#3072DD;'"
                             @click.stop="rowClick(scope.row, item.colKey)">
                            {{ item.toDetailText?item.toDetailText:'详情'
                            }}
                        </div>
                        <div class="tdClick" v-else-if="item.isCanClickInclude&&item.isCanClickInclude!=',,'" :style="(item.isHideCanClickColor?item.isColor?'color:'+scope.row.baseColor+';':'':'color:#ff0000;')+(item.isCanClickInclude.indexOf(','+scope.row.isCanClickInclude+',')!=-1?'text-decoration: underline;cursor:pointer;':'')" @click.stop="item.isCanClickInclude.indexOf(','+scope.row.isCanClickInclude+',')!=-1?rowClick(scope.row.id,item.colKey):''">
                            <div class="tdClickImage" v-if="!item.isHideShowClickImg"></div>
                            {{ scope.row[item.colKey] }}
                        </div>
                        <div class="tdClick" v-else-if="item.isCanClickUnInclude&&item.isCanClickUnInclude!=',,'" :style="(item.isHideCanClickColor?item.isColor?'color:'+scope.row.baseColor+';':'':'color:#ff0000;')+(item.isCanClickUnInclude.indexOf(','+scope.row.isCanClickUnInclude+',')!=-1?'':'text-decoration: underline;cursor:pointer;')" @click.stop="item.isCanClickUnInclude.indexOf(','+scope.row.isCanClickUnInclude+',')!=-1?'':rowClick(scope.row.id,item.colKey,scope.row)">
                            <div class="tdClickImage" v-if="!item.isHideShowClickImg"></div>
                            {{ scope.row[item.colKey] }}
                        </div>
                        <div class="tdClick" v-else-if="item.backClick&&(scope.row.status==2||scope.row.auditor_status==2)" :style="'color:#ff0000;text-decoration: underline;cursor:pointer;'" @click.stop="backClick(scope.row.id)">
                            <div class="tdbackClickImage"></div>
                            {{ scope.row[item.colKey] }}
                        </div>
                        <div class="tdClick tdClickStock" v-else-if="item.isDialogView">
                            {{ scope.row[item.colKey] }}
                            <span class="dialogViewClickClickImagebackRecord tdIcon" style="cursor:pointer;" v-if="scope.row.isDialogViewReturnId" @click.stop="dialogViewClick(scope.row,'return_id')"></span>
                            <span class="dialogViewClickClickhe tdIcon" style="cursor:pointer;" v-if="scope.row.isDialogViewAdIdHe" @click.stop="dialogViewClick(scope.row,'ad_id')"></span>
                            <span class="dialogViewClickClickchai tdIcon" style="cursor:pointer;" v-if="scope.row.isDialogViewAdIdChai" @click.stop="dialogViewClick(scope.row,'ad_id')"></span>
                            <span class="dialogViewClickClickMove tdIcon" style="cursor:pointer;" v-if="scope.row.isDialogViewMove_order_id" @click.stop="dialogViewClick(scope.row,'move_order_id')"></span>
                            <span class="dialogViewClickClickTranslate tdIcon" style="cursor:pointer;" v-if="scope.row.isDialogViewTranslate_id" @click.stop="dialogViewClick(scope.row,'translate_id')"></span>
                            <span class="dialogViewClickClickrong tdIcon" style="cursor:pointer;" v-if="scope.row.isDialogViewrong" ></span>
                            <span class="dialogViewClickClickNobreed tdIcon" style="cursor:pointer;" v-if="scope.row.isDialogViewbreed" @click.stop="dialogViewClick(scope.row,'breed')"></span>
                        </div>
                        <div class="tdClick tdClickStock" v-else-if="item.isassembleView">
                            {{ scope.row[item.colKey] }}
                            <span class="dialogViewClickClickhe tdIcon" title="合包" v-if="scope.row.isDialogViewAdIdHe"></span>
                            <span class="dialogViewClickClickchai tdIcon" title="拆包" v-if="scope.row.isDialogViewAdIdChai"></span>
                            <span class="dialogViewClickClickTranslate tdIcon" title="翻包" v-if="scope.row.isDialogViewTranslate_id"></span>
                        </div>
                        <div class="tdClick tdClickStock" v-else-if="item.isAreaDialogView">
                            <template v-if="!scope.row.isDialogViewArea">
                                <div>
                                    {{ scope.row[item.colKey] }}
                                </div>
                            </template>
                            <template v-if="scope.row.isDialogViewArea">
                                <el-popover placement="right" width="280" trigger="click" popper-class="popoverStyle">
                                    <div>
                                        <span class="bold">提示:<br/></span>
                                        <span>自建仓库没有选择区域！<br/></span>
                                        <span>请到<span class="bold">下拉设置-仓库名称</span>找到仓库点击修<br/></span>
                                        <span>改下拉选择归属区域后，即可同步云链</span>
                                    </div>
                                    <div slot="reference">
                                        {{ scope.row[item.colKey] }}
                                        <span  class="dialogViewClickClickArea tdIcon"></span>
                                    </div>
                                </el-popover>
                            </template>
                        </div>
                        <div class="tdClick cursorPointer" v-else-if="item.isPopout" :style="(item.isHideCanClickColor? item.isColor? 'color:' + scope.row.baseColor + ';': '': 'color:#ff0000s;') + 'text-decoration: underline;'">
                                <div @click.stop="popoutClick(scope.row,item.colKey)">
                                    {{ scope.row[item.colKey] }}
                                </div>
                            </div>
                        <div v-else-if="item.isHoverClick" class="hoverClick" @click.stop="hoverClick(scope.row,item.colKey)" style="width:100%;height:23px;cursor:pointer;">
                            {{ scope.row[item.colKey]}}
                        </div>
                        <div v-else-if="item.noZero" :class="scope.row['un_pay_amount']>0?'hoverClick':''" @click.stop="scope.row['un_pay_amount']>0?rowClick(scope.row.id,item.colKey,scope.row):''" :style="scope.row['un_pay_amount']>0?'color: rgb(255, 0, 0);;text-decoration: underline;cursor: pointer;':''">
                            {{ scope.row[item.colKey]}}
                        </div>
                        <div v-else-if="item.cusFunc" :style="item.cusStyle?item.cusStyle:''"
                             :title="item.showTitle?item.showTitle:''">
                            {{item.cusFunc(scope.row)}}
                        </div>
                        <div v-else-if="item.htmlNodeFunc" :style="item.cusStyle?item.cusStyle:''"
                             :title="item.showTitle?item.showTitle:''">
                            <div v-html="item.htmlNodeFunc&&item.htmlNodeFunc(scope.row)"
                                 @click="item.htmlClickFunc&&item.htmlClickFunc(scope.row,$event)"
                                 @mouseenter="item.htmlHoverFunc&&item.htmlHoverFunc(scope.row,$event)"
                            ></div>
                        </div>
                        <!--可预览图片（单个）-->
                        <div v-else-if="item.isViewerSingleImg" :style="item.cusStyle?item.cusStyle:''">
                            <viewer style="display: flex;align-items: center;justify-content: left;">
                                <img :style="item.imgStyle?item.imgStyle:'width: 30px;height: 30px;cursor:pointer'"
                                     :src="scope.row[item.colKey]" v-if="scope.row[item.colKey]"
                                     :title="item.showTitle?item.showTitle:'点击查看'">
                            </viewer>
                        </div>
                        <!--是否为日期时间,则转换时间戳-->
                        <div v-else-if="item.isFullDate" :style="item.cusStyle?item.cusStyle:''"
                             :title="item.showTitle?item.showTitle:''">
                            {{scope.row[item.colKey]|dateFormat_}}
                        </div>
                        <!--是否为日期-->
                        <div v-else-if="item.isDate" :style="item.cusStyle?item.cusStyle:''"
                             :title="item.showTitle?item.showTitle:''">
                            {{scope.row[item.colKey]|dateFormat}}
                        </div>

                        <div v-else-if="item.isMagnifier" class="tdClick" @click.stop="scope.row.isMagnifier?magnifierClick(scope.row,item.colKey):''" :style="scope.row.isMagnifier?'text-decoration: underline;cursor:pointer;':''">
                            <div class="tdClickMagnifier" v-if="scope.row.isMagnifier"></div>
                            {{ scope.row[item.colKey]}}
                        </div>
                        <div v-else-if="item.islockLevel">
                            <div class="starList clearfix">
                                <div v-if="!!scope.row[item.colKey].name" :title="scope.row[item.colKey].description">
                                    <div class="gradeStarTable" v-for="ind of parseInt(scope.row[item.colKey].name)" :key="ind"></div>
                                </div>
                            </div>
                        </div>
                        <div v-else-if="item.isOpreationLog">
                            <div :class="[scope.row.platform==2?'isPhoneLog':'']">{{ scope.row[item.colKey] }}</div>
                        </div>
                        <div v-else-if="item.isImg">
                            <img v-if="scope.row[item.colKey]!=''&&scope.row[item.colKey]!=0" :src="scope.row[item.colKey]!=''&&scope.row[item.colKey]!=0?scope.row[item.colKey]:''" style="width:20px;height:20px;"/>
                        </div>
                        <div v-else-if="item.isStockImg" class="isStockImg">
                            <viewer :images="scope.row.images"> 
                                    <img v-for="(src,index) in scope.row.images" v-show="index < 1" class="viewImg" :src="src" :key="index"/>
                            </viewer>
                            <!-- <img @click.stop="showStockImg(scope.row.images)" v-if="scope.row[item.colKey]!=''&&scope.row[item.colKey]!=0" :src="scope.row[item.colKey]!=''&&scope.row[item.colKey]!=0?scope.row[item.colKey]:''" style="width:20px;height:20px;cursor:pointer;"/> -->
                        </div>
                        <div v-else-if="item.isStockImgB" class="isStockImg">
                            <viewer :images="scope.row.files" v-if="scope.row.files.length==0"> 
                                -
                            </viewer>
                            <viewer :images="scope.row.files" v-else> 
                                <template v-for="(em,index) in scope.row.files">
                                    <img v-show="index < 1" class="viewImg" :src="em.url" :key="index"/>
                                </template>
                            </viewer>
                            <!-- <img @click.stop="showStockImg(scope.row.images)" v-if="scope.row[item.colKey]!=''&&scope.row[item.colKey]!=0" :src="scope.row[item.colKey]!=''&&scope.row[item.colKey]!=0?scope.row[item.colKey]:''" style="width:20px;height:20px;cursor:pointer;"/> -->
                        </div>
                        <div v-else-if="item.isArray" :style="item.isColor?'color:'+scope.row.baseColor+';':''">
                            <span v-for="(li,index) in scope.row[item.colKey]" :key="index">
                                {{li}}
                                <br/>
                            </span>
                        </div>
                        <div v-else-if="item.isStatus">
                            <div @click="statusClick(scope.row.id,scope.row.status)" :class="['tableStatus',scope.row.status==1?'tableStatusChecked':'']">{{scope.row.status==1?'已开启':'已禁用'}}</div>
                        </div>
                        <div v-else-if="item.isRelativeFile" @click.stop="relativeFile(scope.row.files)">
                            <img v-if="scope.row.files==null||scope.row.files.length==0" src="/icon/associatedfiles.png" style="width:23px;height:23px;cursor:pointer;display:block;margin:auto;"/>
                            <img v-else src="/icon/associatedfilesb.png" style="width:23px;height:23px;cursor:pointer;display:block;margin:auto;"/>
                        </div>
                        <div v-else-if="item.isSignFile" @click.stop="relativeFile(scope.row.sign_order)">
                            <img v-if="scope.row.sign_order==null||scope.row.sign_order.length==0" src="/icon/associatedfiles.png" style="width:23px;height:23px;cursor:pointer;display:block;margin:auto;"/>
                            <img v-else src="/icon/associatedfilesb.png" style="width:23px;height:23px;cursor:pointer;display:block;margin:auto;"/>
                        </div>
                        <div v-else-if="item.isSignContract" @click.stop="relativeFile(scope.row.contract)">
                            <img v-if="scope.row.contract==null||scope.row.contract.length==0" src="/icon/associatedfiles.png" style="width:23px;height:23px;cursor:pointer;display:block;margin:auto;"/>
                            <img v-else src="/icon/associatedfilesb.png" style="width:23px;height:23px;cursor:pointer;display:block;margin:auto;"/>
                        </div>
                        <div v-else-if="item.isRecordView">
                            <img src="/icon/recorda.png" style="width:23px;height:23px;cursor:pointer;display:block;margin:auto;" v-if="scope.row.isDialogViewrecorda" @click.stop="dialogViewClick(scope.row,'process_remark')"/>
                            <img src="/icon/recordb.png" style="width:23px;height:23px;cursor:pointer;display:block;margin:auto;" v-if="scope.row.isDialogViewrecordb" @click.stop="dialogViewClick(scope.row,'process_remark')"/>
                        </div>             
                        <span v-else :style="item.isColor?'color:'+scope.row.baseColor:''">
                            <span v-if="scope.row[item.colKey] == '未签' " style="color:red">
                                {{ scope.row[item.colKey] }}
                            </span>
                            <span v-else>
                                {{ scope.row[item.colKey] }}
                            </span>
                        </span>
                    </template>
                </el-table-column>
            </template>
        </el-table>
    </div>
</template>
<script>
import bus from "../eventBus";
export default {
    //isCanSelection 库存选择商品是判断是否锁定，锁定状态不可选择，（参数不是必传，不传为false）false：未锁定  true:锁定
    //isForeclosure //跳转提前赎货页面
    //isEdit 数据是判断是否可以修改，（参数不是必传，不传false）true：可修改  false:不可修改
    //isDelete 数据是判断是否可以删除，（参数不是必传，不传false）true：可删除  false:不可删除
    //isSee 数据是判断是否可以查看，（参数不是必传，不传false）true：可查看  false:不可查看
    //isShow 数据是判断是否展示对应字段的列，（参数不是必传，不传false）true：展示  false:不展示
    //isSetWidth 数据是判断是否设置对应字段的列宽度，（参数不是必传，不传false）true：展示  false:不展示
    //colWidth 数据设置对应字段的列宽度的数值，（isSetWidth参数为true必传）int类型
    //isCanClick 数据某个字段是否可以点击，（参数不是必传，不传false）true：可点击  false:不点击  ，返回对象{id,name} id为对应一条数据的id name为点击数据的字段key
    //isHideShowClickImg 数据某个字段可以点击情况下，是否展示旁边的图标，（参数不是必传，不传false）true：展示  false:不展示
    //isHideCanClickColor 判断是否修改可点击字段的颜色，（参数不是必传，不传false）true：红色  false:默认色
    //isColor 对应字段是否设置颜色，（参数不是必传，不传false）true：设置  false:不设置
    //baseColor 设置对应字段的颜色，和isColor组合用（isColor参数为true必传），传颜色的16进制或者rgb  string类型 
    //isDialogView 列表查看详情，isDialogViewReturnId同时为true时可查看库存管理的退货记录，isDialogViewAdId同时为true时可查看库存管理的组装拆卸记录
    //isassembleView查看是否有组装拆卸数据
    //isRong 判断是否为融资单
    //isCanClickUnInclude 控制每个td的是否可点击，tableCol里添加需要过滤的值，例如:isCanClickUnInclude:',0,'   每个值用逗号隔开。在对每行的数据添加isCanClickUnInclude的值，出现的值为不可点击项
    //isCanClickInclude 控制每个td的是否可点击，tableCol里添加需要过滤的值，例如:isCanClickInclude:',0,'   每个值用逗号隔开。在对每行的数据添加isCanClickInclude的值，出现的值为可点击项
    //islockLevel 仅为锁货等级展示星星使用
    //isOpreationLog 是否是操作日志，展示手机端和pc端的区别
    //isHoverClick 赎单日点击
    //isRelativeFile 是否是关联文件
    //isStatus 状态开启关闭
    //isMagnifier 是否有放大镜
    //noZero 抹零
    //htmlNodeFunc
    //isSignFile 签单详情
    //isSignContract 签单合同
    props:{
        tablecol:{
            type:Array
        },
        tabledata:{
            type:Array
        },
        selecttype:{
            type:Number
        },
        operationWidth:{
            type:Number
        },
        isShowIndex:{
            type:Boolean
        },
        isLoading:{
            type:Boolean
        },
        isHideColumn:{
            type:Boolean,
            default:true
        },
        scene: {
            type: String,
        },
        isSetCol: {
            type: Boolean,
            default: false,
        },
    },
    mounted(){},
    data(){
        return{
            tableColVal:this.tablecol,
            tableDataVal:this.tabledata,
            borderVal: this.border,
            isAlignCenterVal: this.isAlignCenter,
            operation:false,
            type:this.selecttype?this.selecttype:0,
            selectRow:[],
            sceneC: this.scene,
            photo:[],
            isShowPhoto:false,
            isIndex:this.isShowIndex,
            dragStart: -1,
            dragEnd: -1,
            emptyTextS: this.emptyText
        }
    },
    methods:{
        setEmptyText(text) {
                this.emptyTextS = text;
            },
        togDragClass(enter = false) {
            let c = "thead-cell";
            if (enter) {
                c = "thead-cell dragEnter";
            }
            return c;
        },
        handleMouseLeave(e, column) {
            e.target.classList = this.togDragClass(false);
        },
        handleMouseEnd(e, column) {
            let startDom = null;
            let endDom = null;
            let startIndex = null;
            let endIndex = null;
            let col = JSON.parse(JSON.stringify(this.tableColVal));
            col.forEach((item, index) => {
                if (index == this.dragStart) {
                    startDom = JSON.parse(JSON.stringify(item));
                    startIndex = index;
                }
                if (index == this.dragEnd) {
                    endDom = JSON.parse(JSON.stringify(item));
                    endIndex = index;
                }
            });
            if (startIndex != endIndex) {
                if (this.dragStart - this.dragEnd > 0) {
                    col.splice(this.dragEnd, 0, startDom);
                    col.splice(this.dragStart + 1, 1);
                } else {
                    col.splice(this.dragEnd + 1, 0, startDom);
                    col.splice(this.dragStart, 1);
                }
                this.tableColVal = col;
                // let obj = new Object();
                // obj.start = startIndex;
                // obj.end = endIndex;
                let emit = ("changeHeadSort" + this.sceneC).replace(/\./g, "");
                bus.$emit(emit, col);
            }
        },
        handleMouseStart(e, column) {
            this.dragStart = parseInt(column.columnKey);
        },
        handleMouseMove(e, column) {
            e.target.classList = this.togDragClass(true);
            this.dragEnd = parseInt(column.columnKey);
        },
        renderHeader(createElement, {column}) {
            return createElement(
                "span",
                {
                    class: ["thead-cell"],
                    attrs: {
                        draggable: true,
                    },
                    on: {
                        dragstart: ($event) => {
                            $event.dataTransfer.effectAllowed = "all";
                            this.handleMouseStart($event, column);
                        },
                        dragenter: ($event) => {
                            $event.dataTransfer.dropEffect = "move";
                            this.handleMouseMove($event, column);
                        },
                        dragleave: ($event) => {
                            this.handleMouseLeave($event, column);
                        },
                        dragend: ($event) => {
                            this.handleMouseEnd($event, column);
                        },
                        dragover:($event)=>{
                            $event.preventDefault();
                        },
                        drop:($event)=>{
                            $event.target.classList = this.togDragClass(false);
                        }
                    },
                },
                column.label,
                [
                    // createElement('span', column.label),
                    // createElement('span', {
                    //     'class': ['virtual']
                    // })
                ]
            );
        },
        headDrog(newWidth, oldWidth, column) {
            if (this.isSetCol) {
                this.tableColVal.forEach((item) => {
                    if (column.property == item.colKey) {
                        item.colWidth = newWidth;
                    }
                });
                let obj = {};
                obj.width = parseInt(newWidth);
                obj.name = column.property;
                let emit = ("changeHeadWidth" + this.sceneC).replace(/\./g, "");
                bus.$emit(emit, obj);
            }
        },
        cellClass({row, column, rowIndex, columnIndex}) {
            let isHideCheckout = this.isHideCheckout ? 2 : 1;
            if (columnIndex === isHideCheckout) {
                // 指定列号
                if (this.operation) {
                    return "cellOperaation";
                } else {
                    return "";
                }
            } else {
                return "";
            }
        },
        magnifierClick(row,type){
            let obj = new Object();
            obj.row = row;
            obj.type = type;
            this.$emit("magnifierClick",obj)
        },
        sortThisColumn(column){
            let obj = new Object();
            obj.order = column.order;
            obj.prop = column.prop;
            this.$emit("sortTable",obj)
        },
        statusClick(id,status){
            let obj = new Object();
            obj.id = id;
            obj.status = status;
            this.$emit("statusClick",obj)
        },
        relativeFile(files){
            let obj = new Object();
            obj.files = files;
            this.$emit("relativefile",obj)
        },
        hoverClick(row,name){
            row.hoverClickName = name;
            this.$emit("hoverClick",row)
        },
        checkSelectable(row){
            if(row.isCanSelection){
                return false;
            }else{
                return true;
            }
        },
        tableRowClassName({row}) {
            for(let i=0;i<this.selectRow.length;i++){
                if(this.selectRow[i].id){
                    if(this.selectRow[i].id==row.id){
                        return 'selectRow';
                    }
                }else if(this.selectRow[i].issuing_id){
                    if(this.selectRow[i].issuing_id==row.issuing_id){
                        return 'selectRow';
                    }
                }
                else{
                    if(this.selectRow[i].area_id==row.area_id&&this.selectRow[i].brand_id==row.brand_id&&this.selectRow[i].breed_id==row.breed_id
                    &&this.selectRow[i].grade_id==row.grade_id&&this.selectRow[i].length==row.length&&this.selectRow[i].thickness==row.thickness
                    ){
                        return 'selectRow';
                    }
                }
            }
            return '';
        },
        toggleSelection(row) {
            if(row.sales_select==0){
                this.tip('无权限不可销售','info')
            }
            if(!row.isCanSelection){
                if(this.type!=0){
                    this.$refs.tableList.clearSelection()
                }
                this.$refs.tableList.toggleRowSelection(row);
            }
        },
        dialogViewClick(row,type){
            let obj = new Object();
            obj.row = row;
            obj.type = type;
            this.$emit("dialogViewClick",obj)
        },
        selectionChange(row){
            this.selectRow = row;
            this.$emit("getRow",row)
        },
        deleteF(id,row){
            this.$emit("getTableDelete",id,row)
        },
        see(id){
            this.$emit("getTableSee",id)
        },
        recall(id,row){
            this.$emit("recall",id,row)
        },
        seeSaleBill(id,row){
            this.$emit("seeSaleBill",id,row)
        },
        edit(id,row){
            this.$emit("getTableEdit",id,row);
        },
        transfer(id,row){
            this.$emit("getTransfer",id,row);
        },
        foreclosure(id,row){
            this.$emit("getToforeclosure",id,row);
        },
        popoutClick(item,name){
            this.$emit("ball", {
                item:item,
                name:name
            });
        },
        rowClick(id,name,row){
            this.$emit("rowClick", {
                id:id,
                name:name,
                row: row
            });
        },
        backClick(id){
            this.$emit("backClick",id);
        },
        isCancel(id){
            this.$emit("isCancel",id)
        }
    },
    watch:{
        "tabledata":function(val){
            this.tableDataVal=val;
            this.tableDataVal.forEach(item=>{
                if(item.isEdit||item.isDelete||item.isSee||item.isRevoke||item.isDetail||item.isCancel||item.isForeclosure||item.is_transfer){
                    this.operation=true;
                }
            })
        },
        "isShowIndex":function(val){
            this.isIndex = val;
        },
        tablecol: function (val) {
            this.tableColVal = val;
        },
        scene: {
            immediate: true,
            handler: function (val) {
                this.sceneC = val;
            },
        },
        border: function (val) {
            this.borderVal = val;
        },
        isAlignCenter: function (val) {
            this.isAlignCenterVal = val;
        },
        // "isLoading":function(val){
        //     if(!val){
        //         // let boxHeight = document.getElementById("tableTempleteBox").offsetHeight ? document.getElementById("tableTempleteBox").offsetHeight : document.getElementById("elTable").offsetHeight;
        //         // document.getElementById("tableTempleteBox").getElementsByClassName("el-table__body-wrapper")[0].style.cssText = (boxHeight - 37)+"px;";
        //     }
        // }
    }
}
</script>
<style scoped>
    .tableTempleteBox >>> .thead-cell {
        width: 100%;
        display: inline-block;
    }
    .tableTempleteBox >>> .dragEnter {
        display: block;
        background-color: #b1d2a8 !important;
    }

    .oper_fore{color: #f7A502;text-decoration:underline;cursor:pointer;}
    /* .tableTempleteBox >>> .el-table{display: flex;flex-direction: column;height:100%;}
    .tableTempleteBox >>> .el-table__header-wrapper{height: 37px;overflow-y: auto;overflow-x: hidden;overflow: unset;}
    .tableTempleteBox >>> .el-table__body-wrapper{height: 100% !important;flex: 1;} */
    .tableTempleteBox >>> .table-fixed .el-table__body-wrapper {height: calc(100% - 44px) !important;}
    .starList .gradeStarTable{float: left;margin-right:5px;}
    .viewImg{width:50px;height:23px;cursor: pointer;display: block;margin:auto;}
    .tableStatus{padding:1px 10px;border-radius: 3px;background: #EEE;color: #B21111;text-align: center;cursor: pointer;}
    .tableStatusChecked{background: #F9A602;color: #fff;}
    .tableTempleteBox >>> .el-table th.gutter{width:7px!important;}
    .tableTempleteBox >>> .el-table--border::after, .el-table--group::after, .el-table::before{content: none;}
    /* .tableTempleteBox >>> .el-table th.is-leaf{height:37px;overflow: hidden;} */
    .tableTempleteBox >>> .el-table th{padding: 0}
    .tableTempleteBox >>> .el-table th>.cell{max-height: 35px; height:100%; overflow: hidden;display: flex;align-items: center; padding: 0;}
    .tableTempleteBox >>> .el-table .caret-wrapper{display: flex;flex-basis: 36px;}
    .tableTempleteBox >>> .el-table th>.cell .thead-cell{padding: 6px 10px;}
    .tableTempleteBox >>> .el-table tr .tableIndex .cell{display: flex;justify-content: flex-start;padding:0 10px;}
</style>